import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function TeamSection() {
  const [selectedMember, setSelectedMember] = useState<typeof teamMembers[0] | null>(null);
  const [showAllMobile, setShowAllMobile] = useState(false);

  const teamMembers = [
    {
      name: 'Mwaniki Andrew',
      role: 'Fitness Instructor | Spin Coach | Personal Trainer',
      specialties: ['Strength Training', 'Weight Loss', 'Endurance Building', 'Spin Classes'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/d75076b80dffc9190437378af01e43ac.png',
      motto: 'No excuses, just results.',
      bio: 'Mwaniki Andrew is a passionate and experienced fitness instructor, spin coach, and personal trainer dedicated to helping clients achieve their strength, weight loss, and overall fitness goals. He brings unmatched energy, motivation, and discipline to every session, ensuring lasting results and a transformative fitness experience.',
      philosophy: 'Known for high-energy sessions that inspire commitment, consistency, and results. Specialized in strength training, weight loss, endurance building, and spin classes.'
    },
    {
      name: 'Roman Agesa',
      role: 'Personal Trainer',
      specialties: ['Strength Training', 'Nutrition', 'Circuit Training'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/6916d9de34509c4e597100567fe772ae.png',
      motto: 'Consistency, discipline, and hard work bring results.',
      bio: 'Roman Agesa is a dedicated personal trainer with a passion for helping clients achieve their fitness goals through personalized training programs. With expertise in strength training, nutrition, and circuit training, Roman creates comprehensive fitness plans that deliver real results.',
      philosophy: 'Roman believes that true transformation comes from consistency and dedication. His approach combines scientific training methods with motivational coaching to help clients push past their limits and achieve sustainable results.'
    },
    {
      name: 'Eugene Louis',
      role: 'Certified Fitness Coach',
      specialties: ['One-on-One Training', 'Mobility & Flexibility', 'Healthy Lifestyle Coaching'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/d74a47fe54e7874c1d53b59f854e6a1b.png',
      motto: 'Building Confidence, Strength, and Balanced Lifestyles.',
      bio: 'Eugene Louis is a certified and highly motivated fitness coach with over six years of experience specializing in weight loss, muscle building, and strength and conditioning. His coaching philosophy is rooted in a supportive and motivating approach, dedicated to creating personalized plans that deliver long-term, sustainable results for his clients.',
      philosophy: 'Eugene\'s passion for fitness began as a personal quest to become stronger and healthier. This profound personal transformation ignited a desire to help others, turning his passion into a purposeful career. Over the past six years, he has honed his expertise, earning his certification from Zoezi Fitness School and developing a coaching style that empowers clients to build confidence and achieve their best selves, both physically and mentally.'
    },
    {
      name: 'Coach Eve',
      role: 'Strength Training | Functional Workouts | Bodybuilding | Holistic Coaching',
      specialties: ['Strength Training', 'Functional Workouts', 'Bodybuilding', 'Holistic Coaching'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/367905bdf8bc8178233219cc83d40283.png',
      motto: 'Building Strength, Discipline, and Confidence for Sustainable Results.',
      bio: 'A highly certified and experienced fitness professional with over 15 years in the industry, holding credentials as a Personal Trainer, Group Fitness Trainer, and a Diploma in CrossFit and Gym Training. Specializes in delivering transformative results through strength training, functional workouts, bodybuilding, and studio classes, supported by expert guidance in basic nutrition and supplementation.',
      philosophy: 'For over 15 years, my career has been dedicated to the profound belief that fitness is a holistic lifestyle, not just a routine. This philosophy has been the driving force behind every training session, focusing on unifying the mind, body, and spirit to break through barriers and achieve progress. My extensive experience is built on empowering clients to build not only physical strength but also mental fortitude and emotional resilience.'
    },
    {
      name: 'Terence Owate',
      role: 'Certified Fitness Enthusiast | Aspiring Personal Trainer | Bodybuilding & Cycling',
      specialties: ['Bodybuilding', 'Cycling', 'Fitness Training', 'Client Motivation'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/64b8e699ba6e9e84bfc345dc426a5054.png',
      motto: 'Passion, discipline, and consistency transform lives.',
      bio: 'Terence Owate is a certified fitness enthusiast and a personal trainer in the making, passionate about bodybuilding, cycling, and transforming lives through fitness. He is dedicated to helping clients achieve their goals through trusted work ethics, discipline, and a results-driven approach.',
      philosophy: 'Terence is currently expanding his expertise through courses in Fitness, CPR, and First Aid, building a foundation to transition into a professional personal trainer. He actively pursues knowledge to provide safe, effective, and impactful training experiences, driven by the belief that passion, discipline, and consistency are the keys to transformation.'
    },
    {
      name: 'Fariya Abduba',
      role: 'Receptionist | Customer Support | Front Desk Operations',
      specialties: ['Customer Support', 'Front Desk Operations', 'Member Assistance', 'Client Relations'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/263f379771fb3da9a34d2556afc36c15.png',
      motto: 'Service with a smile, support with care.',
      bio: 'Fariya Abduba is a dedicated receptionist skilled in managing front desk operations and providing excellent customer service. With a passion for continuous learning and creativity, she brings professionalism, warmth, and efficiency to every client interaction. Beyond work, Fariya enjoys reading and cooking, reflecting her curiosity and love for growth.',
      philosophy: 'Fariya believes in creating a welcoming environment that motivates members to return. Her approach focuses on smooth check-in processes, clear communication, and ensuring every member feels valued and supported from the moment they walk through the door.'
    },
    {
      name: 'Debra Kosgei',
      role: 'Beginner Fitness Trainer | Recreational Runner',
      specialties: ['Beginner Training', 'Healthy Routines', 'Running', 'Supportive Coaching'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/7fe1b2f09bd8ca72b54f8f0060680737.png',
      motto: 'Start strong, stay consistent, grow at your own pace.',
      bio: 'Debra Kosgei is a beginner fitness trainer dedicated to guiding clients through basic workouts and healthy training routines. Inspired by her own fitness journey, she is passionate about helping others take their first steps toward a stronger, healthier lifestyle.',
      philosophy: 'Alongside training, Debra is a recreational runner, bringing the energy, discipline, and endurance from running into her sessions. She believes in creating a positive and supportive environment where individuals can grow at their own pace while learning the importance of consistency and balance.'
    },
    {
      name: 'Sarah Wakwelo',
      role: 'Front Desk Professional | Client Relations | Administrative Excellence | Customer Service',
      specialties: ['Customer Service', 'Client Relations', 'Administrative Support', 'Front Desk Management'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/80fb09c6411bdbb5a1b8c324e6191c40.png',
      motto: 'A warm welcome, every time.',
      bio: 'Sarah Wakwelo is a highly organized and client-focused front desk professional known for her warm demeanor and exceptional administrative skills. She excels at creating a welcoming environment, managing schedules, and ensuring a seamless and positive experience for every client.',
      philosophy: 'Sarah\'s natural aptitude for organization and her genuine passion for helping others form the foundation of her career. She has honed her skills at the front desk, understanding that a client\'s first impression is paramount. Her journey is defined by a commitment to making every individual feel valued, supported, and efficiently cared for from the moment they arrive.'
    },
    {
      name: 'Albert Zawadi',
      role: 'Certified Fitness Trainer | Strength Training | Nutrition | Functional Training',
      specialties: ['Strength Training', 'Functional Movement', 'Nutrition', 'Science-Based Training'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/64b6a0ee2a53620d674662bdd34cb600.png',
      motto: 'Fitness as a lifestyle for longevity.',
      bio: 'Albert Zawadi is a certified fitness trainer specializing in strength training, functional movement, and science-based nutrition. With years of experience, he helps clients build strength, optimize performance, and develop sustainable habits through personalized training and practical, results-driven fitness—making training effective, enjoyable, and a lifelong pursuit.',
      philosophy: 'From an early age, Albert understood that fitness is more than a hobby—it is the key to a vibrant, long life. Strength training preserves muscle and bone, functional movement enhances mobility and independence. Proper nutrition fuels the body for performance and recovery. His philosophy is not about quick fixes, but consistency, patience, and resilience. By making fitness a daily priority, we don\'t just live longer—we live healthier, happier, and stronger.'
    },
    {
      name: 'Mike Mugula',
      role: 'Fitness Professional | Strength & Conditioning Specialist',
      specialties: ['Strength Training', 'Conditioning', 'Personal Training', 'Fitness Coaching'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/dc1fef5d5e7985af0b6a1c795d1fd936.png',
      motto: 'Passion, Purpose, and Progress.',
      bio: 'Mike Mugula is a dedicated fitness professional specializing in strength and conditioning. With a passion for helping clients achieve their fitness goals, Mike brings expertise, motivation, and a results-driven approach to every training session.',
      philosophy: 'Mike believes in the power of consistent effort and personalized training programs. His approach focuses on building sustainable fitness habits that transform lives both physically and mentally, helping clients unlock their full potential.'
    },
    {
      name: 'Junior Litali',
      role: 'Certified Personal Trainer | International Professional Bodybuilder | Fitness Influencer',
      specialties: ['Strength Training', 'Bodybuilding', 'Resistance Training', 'HIIT'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/3546474b4cc3be74950206b54e4a940b.png',
      motto: 'Hard work, consistency, discipline.',
      bio: 'Junior Litali is a certified personal trainer and international professional bodybuilder dedicated to helping individuals achieve their peak fitness. With a passion for strength, discipline, and results, he inspires and guides clients to unlock their full potential through powerful, methodical training and a winning mindset.',
      philosophy: 'Junior believes that true transformation comes from consistency and dedication. His approach combines scientific training methods with motivational coaching to help clients push past their limits and achieve sustainable results.'
    },
    {
      name: 'Jane Zighe',
      role: 'Gym Trainer | Group Fitness Instructor | Wellness Coach',
      specialties: ['Team Building & Bootcamp Drills', 'High Intensity Interval Training (HIIT)', 'Circuit Training', 'Intermediate & Body Sculpting for Flexibility'],
      image: 'https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/2835f2e510ca02a66c4060313a7badd0.png',
      motto: 'Train with intention, move with purpose, live healthier from the inside out.',
      bio: 'Jane Zighe is a passionate and energetic gym trainer committed to helping people transform their lives through fitness. She specializes in both private and group training, offering a dynamic blend of strength, flexibility, and high-intensity programming. With a focus on consistency and mindset, she helps clients at every level unlock their full potential.',
      philosophy: 'Jane creates inclusive, energizing, and purposeful sessions that improve strength, mobility, endurance, and overall balance. Her approach combines a variety of fitness classes designed to challenge, inspire, and deliver lasting results. She believes in both physical and mental transformation, helping clients build confidence, strength, and balanced lifestyles.'
    }
  ];

  return (
    <section id="team" className="py-6 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-4 lg:mb-12">
          <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-100 text-red-700 rounded-lg text-[10px] lg:text-sm font-bold mb-1.5 lg:mb-3 uppercase tracking-wider">
            OUR TEAM
          </div>
          <h3 className="text-xl lg:text-5xl font-black text-gray-900 mb-1.5 lg:mb-4 tracking-tight">
            Meet Our <span className="text-red-600">Expert Team</span>
          </h3>
          <p className="text-[10px] lg:text-lg text-gray-600 max-w-3xl mx-auto hidden lg:block">
            Our professional team is dedicated to helping you achieve your fitness goals
          </p>
        </div>

        {/* Team Members - Show 4 on mobile by default */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-1.5 lg:gap-8">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className={`group relative rounded-lg lg:rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 ${
                !showAllMobile && index >= 4 ? 'hidden lg:block' : ''
              }`}
            >
              {/* Image */}
              <div className="relative h-28 lg:h-96">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                
                {/* Info Button */}
                <button
                  onClick={() => setSelectedMember(member)}
                  className="absolute bottom-1 right-1 lg:bottom-4 lg:right-4 w-6 h-6 lg:w-12 lg:h-12 bg-red-600 hover:bg-red-700 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer z-10"
                  aria-label={`View ${member.name} details`}
                >
                  <i className="ri-information-line text-white text-[10px] lg:text-xl"></i>
                </button>

                {/* Name Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-1 lg:p-4">
                  <h4 className="text-[10px] lg:text-xl font-black text-white mb-0 leading-tight">
                    {member.name}
                  </h4>
                  <p className="text-[8px] lg:text-sm text-gray-200 line-clamp-1 hidden lg:block">
                    {member.role.split('|')[0]}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button - Mobile Only */}
        {!showAllMobile && teamMembers.length > 4 && (
          <div className="lg:hidden text-center mt-3">
            <Button
              onClick={() => setShowAllMobile(true)}
              variant="primary"
              icon="ri-arrow-down-s-line"
              iconPosition="right"
              className="text-[10px] px-4 py-2"
            >
              View All Team ({teamMembers.length})
            </Button>
          </div>
        )}
      </div>

      {/* Modal */}
      {selectedMember && (
        <div 
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedMember(null)}
        >
          <div 
            className="bg-white rounded-xl lg:rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-slideUp"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header with Image */}
            <div className="relative h-40 lg:h-80 rounded-t-xl lg:rounded-t-3xl overflow-hidden">
              <img
                src={selectedMember.image}
                alt={selectedMember.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
              
              {/* Close Button */}
              <button
                onClick={() => setSelectedMember(null)}
                className="absolute top-2 right-2 lg:top-4 lg:right-4 w-7 h-7 lg:w-10 lg:h-10 bg-white/20 backdrop-blur-md hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                aria-label="Close modal"
              >
                <i className="ri-close-line text-white text-lg lg:text-2xl"></i>
              </button>

              {/* Name & Role */}
              <div className="absolute bottom-0 left-0 right-0 p-3 lg:p-8">
                <h3 className="text-xl lg:text-4xl font-black text-white mb-0.5 lg:mb-2">
                  {selectedMember.name}
                </h3>
                <p className="text-xs lg:text-lg text-gray-200 font-semibold">
                  {selectedMember.role}
                </p>
              </div>
            </div>

            {/* Content */}
            <div className="p-3 lg:p-8">
              {/* Motto */}
              <div className="mb-3 lg:mb-6 p-2 lg:p-4 bg-red-50 border-l-4 border-red-600 rounded-lg">
                <p className="text-xs lg:text-lg font-bold text-red-700 italic">
                  "{selectedMember.motto}"
                </p>
              </div>

              {/* Specialties */}
              <div className="mb-3 lg:mb-6">
                <h4 className="text-sm lg:text-xl font-black text-gray-900 mb-1.5 lg:mb-3 flex items-center gap-2">
                  <i className="ri-star-line text-red-600"></i>
                  Specialties
                </h4>
                <div className="flex flex-wrap gap-1 lg:gap-2">
                  {selectedMember.specialties.map((specialty, idx) => (
                    <span
                      key={idx}
                      className="px-2 lg:px-4 py-0.5 lg:py-2 bg-gray-100 text-gray-800 rounded-lg text-[10px] lg:text-sm font-semibold"
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>

              {/* Bio */}
              <div className="mb-3 lg:mb-6">
                <h4 className="text-sm lg:text-xl font-black text-gray-900 mb-1.5 lg:mb-3 flex items-center gap-2">
                  <i className="ri-user-line text-red-600"></i>
                  About
                </h4>
                <p className="text-gray-700 leading-relaxed text-xs lg:text-base">
                  {selectedMember.bio}
                </p>
              </div>

              {/* Philosophy */}
              <div className="mb-3 lg:mb-6">
                <h4 className="text-sm lg:text-xl font-black text-gray-900 mb-1.5 lg:mb-3 flex items-center gap-2">
                  <i className="ri-lightbulb-line text-red-600"></i>
                  Training Philosophy
                </h4>
                <p className="text-gray-700 leading-relaxed text-xs lg:text-base">
                  {selectedMember.philosophy}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
